export const APP_NAME = 'Kapit'
